export const blogPosts = [
  {
    id: 1,
    title: "Purse-Friendly Luxury Tote Bags for Work and Weekend",
    excerpt:
      "From sleek leather totes to embroidered pieces and more, we bring you the best purse-friendly luxury tote bags for work and the weekend.",
    imageUrl:
      "https://www.azafashions.com/blog/wp-content/uploads/2025/04/Featured-Image-5.jpg",
    imageAlt: "Woman with luxury tote bag",
    content: "Full article content would go here..."
  },
  {
    id: 2,
    title: "A Guide to Add Berry Wine Color To Your Wardrobe",
    excerpt:
    "In love with red, berry wine, burgundy or cherry red color? Here's how you incorporate it to your summer wardrobe.",
    imageUrl:
    "https://www.azafashions.com/blog/wp-content/uploads/2025/04/Best-honeymoon-outfits-for-top-destinations-in-India.jpg",
    imageAlt: "Person with berry wine colored outfit",
    content: "Full article content would go here..."
  },
  {
    id: 3,
    title: "The Best Honeymoon Outfits for India's Top Destinations",
    excerpt:
    "From sensual bikinis to maxi dresses and more, we bring you a roundup of the best honeymoon outfits for India's top romantic destinations.",
    imageUrl:
    "https://www.azafashions.com/blog/wp-content/uploads/2025/04/Featured-Image-6.jpg",
    imageAlt: "Person in hammock at beach destination",
    content: "Full article content would go here..."
  },
  {
    id: 4,
    title: "Say 'I Do' to These Summer Wedding Outfits",
    excerpt:
      'This season, let your wardrobe say: "I do," to every wedding invite you receive and show up in buzzworthy designer outfits from Aza.',
    imageUrl:
      "https://www.azafashions.com/blog/wp-content/uploads/2025/04/Luxury-tote-bags.jpg",
    imageAlt: "Wedding celebration with flowers",
    content: "Full article content would go here..."
  }
];
